<div class="core-ui-file-section" [class.is-error]="error" [attr.aria-invalid]="error">
    <div
        class="core-ui-file-section__header"
        [class.is-action-right]="actionAlign === 'right'"
    >
        <div class="core-ui-file-section__subtitle" *ngIf="fileName">
            <div class="core-ui-file-section__divider"></div>
            {{ attachedLabel }}
        </div>

        <button
            *ngIf="!fileName && !readOnly"
            type="button"
            class="core-ui-file-section__add-document"
            [disabled]="disabled"
            (click)="openFilePicker(fileInput)"
        >
            + <span>{{ emptyActionText }}</span>
        </button>
    </div>

    <div class="core-ui-file-upload">
        <input
            #fileInput
            type="file"
            class="core-ui-file-upload__input"
            [accept]="accept"
            [disabled]="readOnly || disabled"
            (change)="onFileSelected($event)"
        />

        <core-ui-attachment-card
            *ngIf="attachmentItem as item"
            [item]="item"
            [disabled]="disabled"
            [caption]="attachmentCaption"
            [metadataOrder]="metadataOrder"
            [iconName]="iconName"
            [iconColor]="iconColor"
            [dragging]="isDragging"
            (selected)="onFileCardClick(fileInput)"
            (dragover)="onDragOver($event)"
            (dragleave)="onDragLeave($event)"
            (dragend)="onDragEnd()"
            (drop)="onDrop($event)"
        >
            <core-ui-button-base
                *ngIf="!readOnly"
                coreUiAttachmentCardAction
                iconOnly
                variant="tertiary"
                appearance="attachment-action"
                size="sm"
                icon="icon_close"
                iconSize="base"
                style="--core-ui-button-border-radius: 50%"
                [disabled]="disabled"
                [ariaLabel]="'Quitar ' + item.name"
                (clicked)="removeFile()"
            ></core-ui-button-base>
        </core-ui-attachment-card>
    </div>

    <p class="core-ui-file-section__description" *ngIf="description && fileName">
        {{ description }}
    </p>
</div>
